module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAcCAMAAAAkyw3kAAAAM1BMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADlf1jlAAAAEHRSTlMAUM/vQL8QgGqV3yBgr58w15zOUwAAAMBJREFUeNrN00kOwyAMQFEGgwmZ/v1PWzE0rZSEZtm/iSLewpbA8KxkME+a/gGKqpjSnFRtvIUxg5bvSskvNzBuNOjo2QsYJWUaVCDr5CE3sKh8oAAdZgjlGNgrCOgVlA6iiMQzrFWo4M3RAE4Q9hVcPRXenWAAT83FH/Boa5M6NhG5hG424oF5MGOFZVsLLL+WOf4aCMsVTCdYO8O9z2YBO4Imt2Uc+DiE9usxDaHZaE3mDmq/4XYFv8qfvcJnpRcjYxdlnz9l0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_16.png
// module id = 4PVn
// module chunks = 1